import Vue, { VueConstructor } from 'vue';
import AuthService from './services/auth.service';
import AuthorizationService from './services/authorization.service';
declare module 'vue/types/vue' {
  interface Vue {
    $authService: AuthService;
    $authorizationService: AuthorizationService;
  }
}

export default class CoreModule {
  // constructor() {
  //  console.log('creating new instance of CoreModuleService');
  // }
  static install(Vue: VueConstructor<Vue>): void {
    console.log('initiating Auth module');

    Vue.prototype.$authService = new AuthService();
    Vue.prototype.$authorizationService = new AuthorizationService();
  }
}
